import { Inject,Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service'
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { SEO_CONSTANTS } from '../constants';


@Injectable({
  providedIn: 'root'
})
export class SeoService {
  render: any;
  instanceDocument: any;

  schemaOrganization = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: 'chilepasajes.cl',
    url: environment.urlChilePasajes,
    logo: `${environment.urlCdn}/logos/logos_head/pasajes.png`,
    description: 'Chilepasajes es una plataforma web para la compra de pasajes en bus en internet.',
    sameAs: [environment.redes.facebook, environment.redes.twitter, environment.redes.instagram],
    contactPoint: [{
      "@type": "ContactPoint",
      "telephone": "+56225952974",
      "email": "ayuda@chilepasajes.cl",
      "url": `${environment.urlChilePasajes}/es/ayuda`,
      "contactType": "customer support",
      "availableLanguage": ["English", "Spanish"],
      "sameAs": [`${environment.urlChilePasajes}/es/ayuda`]
    }]

  };
  schemaSite = {
    '@context': 'http://schema.org',
    '@type': 'Website',
    name: 'chilepasajes.cl',
    url: environment.urlChilePasajes
  };
  schemaSiteBreadcrumbLis = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbLis',
    itemListElement: [{
      "@type": "ListItem",
      "position": 1,
      "name": "Chilepasajes",
      "item": `${environment.urlChilePasajes}/es`
    }]
  };
  seoConstants = SEO_CONSTANTS;

  constructor(
    public router: Router,
    public meta: Meta,
    private cookieService: CookieService,
    private metaService: Meta,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
  ) { }

  addStructuredData(schema,doc) {
    this.instanceDocument = doc;
    const script = this.instanceDocument.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    this.instanceDocument.body.appendChild(script);
  }

  removeTags(names: any, properties: any) {
    for (const item of names) {
      this.meta.removeTag(`name='${item.key}'`);
    }

    for (let item of properties) {
      this.meta.removeTag(`property='${item.key}'`);
    }
  }
  generateTag(names: any, properties: any, urls: any = []) {
    for (const item of names) {
      // this.meta.addTag({ name: item.key, content: item.value });
      this.meta.updateTag({ name: item.key, content: item.value });
    }

    for (let item of properties) {
      // this.meta.addTag({ property: item.key, content: item.value });
      this.meta.updateTag({ property: item.key, content: item.value });
    }
  }
  // oculatr id servicio sin asientos
  setCookie(name, value, expires) {





    this.cookieService.set(name, value, expires);
  }
  getCookie(name) {


    return this.cookieService.get(name);
  }
  setRender(render) {
    this.render = render;
  }
  setDocument(doc) {
    this.instanceDocument = doc;
  }
  generaAPP(newComplemt) {
    let names = [];
    let properties = [];

    names.push({ key: 'smartbanner:author', value: 'Descargala' });
    names.push({ key: 'smartbanner:price', value: 'Gratis ' });
    names.push({ key: 'smartbanner:button', value: 'Descargar' });
    names.push({ key: 'smartbanner:price-suffix-apple', value: 'en App Store' });
    names.push({ key: 'smartbanner:price-suffix-google', value: 'en Google Play' });
    names.push({ key: 'smartbanner:enabled-platforms', value: 'android,ios' });


    if (newComplemt == 'buses-jeldres') {

      names.push({ key: 'smartbanner:title', value: 'Buses Jeldres APP' });
      names.push({ key: 'smartbanner:icon-apple', value: 'https://play-lh.googleusercontent.com/249TpFPAZFYCDFljgj39dU7o_9UelgKCQ1QC0jy3P9fRjOsWx-COyz690mz1gSmTJ84=s180-rw' });
      names.push({ key: 'smartbanner:icon-google', value: 'https://play-lh.googleusercontent.com/249TpFPAZFYCDFljgj39dU7o_9UelgKCQ1QC0jy3P9fRjOsWx-COyz690mz1gSmTJ84=s180-rw' });
      names.push({ key: 'smartbanner:button-url-apple', value: 'https://apps.apple.com/app/apple-store/id1538294096' });
      names.push({ key: 'smartbanner:button-url-google', value: 'https://play.google.com/store/apps/details?id=io.ionic.jeldres' });
    } else if (newComplemt == 'buses-transantin') {

      names.push({ key: 'smartbanner:title', value: 'Buses Transantin' });
      names.push({ key: 'smartbanner:icon-apple', value: 'https://play-lh.googleusercontent.com/x2U9J86aoW5vzQMMsjoF7xvHr2CFtUh2MEyqSjoUh5GZkwmKPDnApkzjQwo6jGbz8g=s180-rw' });
      names.push({ key: 'smartbanner:icon-google', value: 'https://play-lh.googleusercontent.com/x2U9J86aoW5vzQMMsjoF7xvHr2CFtUh2MEyqSjoUh5GZkwmKPDnApkzjQwo6jGbz8g=s180-rw' });
      names.push({ key: 'smartbanner:button-url-apple', value: 'https://play.google.com/store/apps/details?id=io.chilepasajes.transantin' });
      names.push({ key: 'smartbanner:button-url-google', value: 'https://play.google.com/store/apps/details?id=io.chilepasajes.transantin' });
    } else if (newComplemt == 'buses-altas-cumbres') {

      names.push({ key: 'smartbanner:title', value: 'Altas Cumbres APP' });
      names.push({ key: 'smartbanner:icon-apple', value: 'https://play-lh.googleusercontent.com/NRM8uLnRyVcuxtOKy4wwwwVYemjGE7P4ya7Mza6pfjCCgJYMPey9ta8elVDTealjaFM=s180-rw' });
      names.push({ key: 'smartbanner:icon-google', value: 'https://play-lh.googleusercontent.com/NRM8uLnRyVcuxtOKy4wwwwVYemjGE7P4ya7Mza6pfjCCgJYMPey9ta8elVDTealjaFM=s180-rw' });
      names.push({ key: 'smartbanner:button-url-apple', value: 'https://apps.apple.com/app/apple-store/id1536999900' });
      names.push({ key: 'smartbanner:button-url-google', value: 'https://play.google.com/store/apps/details?id=io.chilepasajes.altas.cumbres' });
    } else if (newComplemt == 'pasajes' || newComplemt == 'buses-pullmantur' || newComplemt == 'turismo-zaahj' || newComplemt == 'buses-paravias') {
      names.push({ key: 'smartbanner:title', value: 'Chilepasajes APP' });
      names.push({ key: 'smartbanner:icon-apple', value: `${environment.urlCdn}/cdn-clp/website/imagenes/varias/chp-min.jpg` });
      names.push({ key: 'smartbanner:icon-google', value: `${environment.urlCdn}/cdn-clp/website/imagenes/varias/chp-min.jpg` });
      names.push({ key: 'smartbanner:button-url-apple', value: environment.app.ios });
      names.push({ key: 'smartbanner:button-url-google', value: environment.app.android });
    }
    this.generateTag(names, properties);
  }
  valuesSeo(t, k, d, og_d, c_n, og_t, og_u, og_i, og_s, c_a, no_index = false) {
    let names = [];
    let properties = [];

    names.push({ key: 'title', value: t });
    names.push({ key: 'keywords', value: k });
    names.push({ key: 'description', value: d });
    properties.push({ key: 'og:description', value: og_d });
    names.push({ key: 'rating', value: 'general' });

    properties.push({ key: 'og:title', value: og_t });
    properties.push({ key: 'og:type', value: 'website' });
    properties.push({ key: 'og:url', value: og_u });
    properties.push({ key: 'og:image', value: og_i });
    properties.push({ key: 'og:site_name', value: og_s });

    if(no_index){
      names.push({ key: 'robots', value: 'noindex,nofollow' });
      names.push({ key: 'googlebot', value: 'noindex,nofollow' });
    }else{
      names.push({ key: 'robots', value: 'index,follow' });
    }

    this.generateTag(names, properties);
    let element: HTMLLinkElement;
    try {
      element = this.instanceDocument.querySelector(`link[rel='canonical']`) || null;
    } catch (error) {

    }
    if (!element) {
      let link: HTMLLinkElement;
      try {
        link = this.render.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', `${c_a}`);
        this.instanceDocument.head.appendChild(link);
      } catch (error) {

      }
    } else {
      element.setAttribute('rel', 'canonical');
      element.setAttribute('href', `${c_a}`);
    }

    let alternate: HTMLLinkElement;

    try {
      alternate = this.instanceDocument.querySelector(`link[rel='alternate']`) || null;
    } catch (error) {

    }
    if(!alternate) {
      try {
        alternate = this.render.createElement('link');
        alternate.setAttribute('rel', 'alternate');
        alternate.setAttribute('hreflang', c_n);
        alternate.setAttribute('href', `${c_a}`);
        this.instanceDocument.head.appendChild(alternate);
      } catch (error) {
  
      }
    }else {
      alternate.setAttribute('rel', 'alternate');
      alternate.setAttribute('href', `${c_a}`);
    }

  }
  UpdateSEO(title_?: string, description_?: string, keywords?:string,lang_?:string) {
    
    const title = title_ || "¡Pasajes en Bus Baratos! Reserva Hoy en Chilepasajes.cl";
    const descripcion = description_ || 'Compra Pasajes de Bus baratos para todo Chile. Compara precios de Flixbus, Jet sur, Transantin y más. ¡Ahorra en tus viajes y reserva tus pasajes ahora!';
    const lang = lang_ || "es";

    const baseUrl = this.document.location.origin;
    const canonicalUrl = `${baseUrl}${this.router.url}`;
    this.titleService.setTitle(title);

    this.meta.updateTag({ name: 'description', content: descripcion });
    this.meta.updateTag({ name: 'keywords', content: keywords });
    this.meta.updateTag({ name: 'lang', content: lang});
    this.meta.updateTag({ name: 'twitter:title', content: title  + " Chilepasajes.cl"});
    this.meta.updateTag({ name: 'twitter:description', content: descripcion  });

    // si es prod 
    /*if (window.location.href.indexOf("/qa.") == -1){
      this.meta.updateTag({ name: 'robots', content: 'index,follow'  });
      this.meta.removeTag("name='googlebot'");
    }*/
    
    const link1: HTMLLinkElement = this.document.querySelector("link[rel='alternate']") || this.document.createElement('link');
    link1.setAttribute('rel', 'alternate');
    link1.setAttribute('hreflang', lang_);
    link1.setAttribute('href', canonicalUrl);
    this.document.head.appendChild(link1);


    const link2: HTMLLinkElement = this.document.querySelector("link[rel='alternate']") || this.document.createElement('link');
    link2.setAttribute('rel', 'alternate');
    link2.setAttribute('hreflang', lang_+'-CL');
    link2.setAttribute('href', canonicalUrl);
    this.document.head.appendChild(link2);

  

    /*const link: HTMLLinkElement = this.document.querySelector("link[rel='canonical']") || this.document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);
    this.document.head.appendChild(link);*/

    this.document.querySelector('html')?.setAttribute('lang', lang);

  }

  getRandomCTA(route: string){
    const ctas: string[] = this.seoConstants.ROUTES[route].ctas;
    return ctas[Math.floor(Math.random() * ctas.length)];
  }

  setTitle(route: string, info: string[]) {
    const placeholderRegex = /\[(.*?)\]/g;
    let replacementIndex = 0;
    const titulo: string = this.seoConstants.ROUTES[route].titulo;

    return titulo.replace(placeholderRegex, (match, placeholder) => {
      if(replacementIndex >= info.length){
        return match;
      }

      return info[replacementIndex++];
    });
  }

  setDescription(route: string, info: string[]) {
    const placeholderRegex = /\[(.*?)\]/g;
    let replacementIndex = 0;
    let descripcion: string = this.seoConstants.ROUTES[route].descripcion;

    // set CTA
    descripcion = descripcion.replace(/\[CTA\]/, this.getRandomCTA(route));

    return descripcion.replace(placeholderRegex, (match, placeholder) => {
      if(replacementIndex >= info.length){
        return match;
      }

      return info[replacementIndex++];
    });
  }


}
